import {useTranslation} from "react-i18next";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Form from "react-bootstrap/Form";
import Offcanvas from "react-bootstrap/Offcanvas";
import {useEffect, useState} from "react";
// -
import axiApi from "ApiCaller";
import {SwalAlertClass} from "core/swalClass";
import useCustomTranslation from "core/customTranslation";
import FormButton from "components/buttons/FormButton";
import SwitcherRadioButtons from "components/switcher/SwitcherRadioButtons";
import {NetworkConfig} from "site-apps/devices/networks/NetworksConfigsModels";

const MqttTypes = {
    BASIC: "b",
    ADVANCED: "a",
    b: "Basic",
    a: "Advanced",
};
const translations = {
    es: {
        "mqtt.type.title": "Tipo de MQTT",
        "mqtt.type.b": "Basico",
        "mqtt.type.a": "Avanzado",
    },
    en: {
        "mqtt.type.title": "MQTT Type",
        "mqtt.type.b": "Basic",
        "mqtt.type.a": "Advanced",
    },
};
const FormConfig = ({
    item,
    items,
    onClickDelete,
    setItemsShown,
    show,
    setShow,
    models,
    servers,
    mqtts,
    ntps,
    gpss,
    isSuperUser,
}) => {
    const {t: _Tf} = useTranslation("forms");
    const {t: _Tt} = useTranslation("tags");
    const {t: _TC} = useCustomTranslation(translations);
    const Alert = new SwalAlertClass({confirmButtonText: _Tf("labels.accept")});
    const [formData, setFormData] = useState({...NetworkConfig});
    // -
    const [modelsWithServers, setModelsWithServers] = useState([]);
    const [modelsWithMqtts, setModelsWithMqtts] = useState([]);
    const [modelsWithNtps, setModelsWithNtps] = useState([]);
    const [modelsWithGPSs, setModelsWithGPSs] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [typeMQTT, setTypeMQTT] = useState(MqttTypes.BASIC);
    // -
    useEffect(() => {
        if (item) {
            filtersByModel(item.model, item.mqtt_type);
            setFormData({...item});
            setTypeMQTT(item.mqtt_type);
        }
    }, [item]);

    useEffect(() => {
        filtersByModel(formData.model, formData.mqtt_type);
    }, [formData.model]);

    useEffect(() => {
        formData.mqtt_type = typeMQTT;
        const mqtts_ = mqtts.filter((mqtt_) => mqtt_.model === formData.model && mqtt_.type === formData.mqtt_type);
        setModelsWithMqtts(mqtts_);
    }, [typeMQTT]);

    const clickCancel = () => {
        setShow(false);
    };
    const handleClose = () => setShow(false);

    const filtersByModel = (model, type) => {
        const servers_ = servers.filter((server_) => server_.model === model);
        const mqtts_ = mqtts.filter((mqtt_) => mqtt_.model === model && mqtt_.type === type);
        const ntps_ = ntps.filter((ntp_) => ntp_.model === model);
        const gpss_ = gpss.filter((gps_) => gps_.model === model);
        setModelsWithServers(servers_);
        setModelsWithMqtts(mqtts_);
        setModelsWithNtps(ntps_);
        setModelsWithGPSs(gpss_);
    };

    const handleChange = (e) => {
        const {name, value, type, checked} = e.target;
        let selectedValue;
        switch (type) {
            case "select-multiple":
                selectedValue = Array.from(e.target.selectedOptions, (option) => option.value);
                break;
            case "select-one":
                selectedValue = Array(value);
                break;
            case "checkbox":
                selectedValue = checked;
                break;
            default:
                selectedValue = value;
                break;
        }
        setFormData((prev) => ({
            ...prev,
            [name]: selectedValue,
        }));
    };

    const clickDelete = () => {
        if (formData.id) {
            onClickDelete(formData.id);
        }
    };

    const onSubmit = (e) => {
        setIsLoading(true);
        e.preventDefault();
        const form = new FormData(e.currentTarget);

        axiApi
            .post("/api/devices/network/", form)
            .then((resp) => {
                if (resp.data.status) {
                    const updatedItem = resp.data.item;

                    if (form.get("id")) {
                        items.current.showed = items.current.showed.map((currentItem) => {
                            if (currentItem.id === updatedItem.id) {
                                return updatedItem;
                            }
                            // if updatedItem is default
                            if (currentItem.model === updatedItem.model && updatedItem.default) {
                                return {...currentItem, default: false};
                            }
                            // para todos.
                            return currentItem;
                        });
                    } else {
                        if (updatedItem.default) {
                            items.current.showed = items.current.showed.map((currentItem) => {
                                if (currentItem.model === updatedItem.model) {
                                    return {...currentItem, default: false};
                                }
                                return currentItem;
                            });
                        }
                        items.current.showed.push(updatedItem);
                    }

                    setItemsShown([...items.current.showed]);
                    Alert.success(_Tf("success.title"));
                }
            })
            .catch((error) => {
                console.error("Error al enviar la solicitud:", error);
                Alert.error(_Tf("errors.not-permitted"), error.response.data.message);
            })
            .finally(() => {
                items.current.clearChosen();
                setIsLoading(false);
            });
    };

    return (
        <Offcanvas show={show} onHide={handleClose} placement="end" backdrop="false" aria-modal={true} style={{width: "700px"}}>
            <Offcanvas.Header className="preview-canvas" closeButton>
                <div className="preview-icon">
                    <FontAwesomeIcon icon="gear" />
                </div>
                <div className="preview-title">
                    <Offcanvas.Title>
                        <label>{_Tt("common.config")}</label>
                        <div>{formData.name}</div>
                    </Offcanvas.Title>
                </div>
            </Offcanvas.Header>
            <Offcanvas.Body>
                <div className="container-fluid">
                    <Form onSubmit={onSubmit} className="row pb-5">
                        <input type="hidden" id="id" name="id" defaultValue={item.id} readOnly={true} />

                        <div className="preview-item">
                            <label>{_Tf("common.name")}</label>
                            <input
                                type="text"
                                className="form-control mb-2"
                                id="name"
                                name="name"
                                defaultValue={formData.name}
                                required
                            />
                        </div>
                        <div className="preview-item">
                            <label>{_Tf("common.description")}</label>
                            <textarea
                                className="form-control mb-2"
                                id="description"
                                name="description"
                                defaultValue={formData.description}
                            />
                        </div>
                        <div className="col-md-6 col-12">
                            <div className="preview-item mt-2">
                                <label htmlFor="model">{_Tt("common.model")}</label>
                                <Form.Select
                                    className="mb-2"
                                    id="model"
                                    name="model"
                                    value={formData.model || ""}
                                    onChange={handleChange}
                                    required>
                                    {models.map((model_, idx) => (
                                        <option key={idx} value={model_}>
                                            {model_}
                                        </option>
                                    ))}
                                </Form.Select>
                            </div>
                        </div>
                        <div className="col-md-6 col-12">
                            <div className="preview-item mt-4 d-flex justify-content-center pt-3">
                                <div className="form-check">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="default"
                                        name="default"
                                        checked={formData.default}
                                        onChange={handleChange}
                                    />
                                    <label className="form-check-label" htmlFor="default">
                                        {_Tt("common.byDefault")}
                                    </label>
                                </div>
                            </div>
                        </div>
                        <hr className="my-4" />
                        <table className="table table-striped">
                            <tbody>
                                <tr>
                                    <td style={{verticalAlign: "middle"}}>{_Tt("network.network")}</td>
                                    <td>
                                        <Form.Select
                                            className="mb-2"
                                            id="server_id"
                                            name="server_id"
                                            value={formData.server_id || ""}
                                            onChange={handleChange}
                                            required
                                            style={{maxWidth: "300px"}}>
                                            <option value="0">Seleccionar</option>
                                            {modelsWithServers.map((server) => (
                                                <option key={server.id} value={server.id}>
                                                    {`${server.name} (${server.model})`}
                                                </option>
                                            ))}
                                        </Form.Select>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{verticalAlign: "middle"}}>MQTT</td>
                                    <td>
                                        <div className="row">
                                            <div className="col-md-6 col-12">
                                                <SwitcherRadioButtons
                                                    name="mqtt_type"
                                                    value={typeMQTT}
                                                    setValue={setTypeMQTT}
                                                    values={["b", "a"]}
                                                    title={_TC("mqtt.type.title")}
                                                    textStart={_TC("mqtt.type.b")}
                                                    textEnd={_TC("mqtt.type.a")}
                                                    classAdd="text-center"
                                                />
                                            </div>

                                            <div className="col-md-6 col-12">
                                                {formData.mqtt_type === MqttTypes.BASIC ? (
                                                    <Form.Select
                                                        className="mb-2"
                                                        id="mqtt_ids"
                                                        name="mqtt_ids"
                                                        value={formData.mqtt_ids[0] || ""}
                                                        onChange={handleChange}
                                                        style={{maxWidth: "200px"}}>
                                                        <option value="0">Seleccionar</option>
                                                        {modelsWithMqtts.map((item) => (
                                                            <option key={"mqtt-" + item.id} value={item.id}>
                                                                {item.name}
                                                            </option>
                                                        ))}
                                                    </Form.Select>
                                                ) : (
                                                    <Form.Select
                                                        multiple
                                                        className="mb-2"
                                                        id="mqtt_ids"
                                                        name="mqtt_ids"
                                                        value={formData.mqtt_ids || []}
                                                        onChange={handleChange}>
                                                        {modelsWithMqtts.map((item) => (
                                                            <option key={"mqtt-" + item.id} value={item.id}>
                                                                {item.name}
                                                            </option>
                                                        ))}
                                                    </Form.Select>
                                                )}
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{verticalAlign: "middle"}}>NTP</td>
                                    <td>
                                        <Form.Select
                                            className="mb-2"
                                            id="ntp_id"
                                            name="ntp_id"
                                            value={formData.ntp_id || ""}
                                            onChange={handleChange}
                                            style={{maxWidth: "300px"}}>
                                            <option value="">Seleccionar</option>
                                            {modelsWithNtps.map((item) => (
                                                <option key={item.id} value={item.id}>
                                                    {item.name}
                                                </option>
                                            ))}
                                        </Form.Select>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{verticalAlign: "middle"}}>GPS</td>
                                    <td>
                                        <Form.Select
                                            className="mb-2"
                                            id="gps_id"
                                            name="gps_id"
                                            value={formData.gps_id || ""}
                                            onChange={handleChange}
                                            style={{maxWidth: "300px"}}>
                                            <option value="">Seleccionar</option>
                                            {modelsWithGPSs.map((item) => (
                                                <option key={item.id} value={item.id}>
                                                    {item.name}
                                                </option>
                                            ))}
                                        </Form.Select>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <div className="row mt-3">
                            <div className="col-12 d-flex justify-content-between mb-5">
                                {item.id ? (
                                    <button
                                        type="button"
                                        className="btn btn-danger"
                                        disabled={!isSuperUser}
                                        onClick={clickDelete}>
                                        <FontAwesomeIcon icon="trash" className="text-white" />
                                    </button>
                                ) : (
                                    <div></div>
                                )}

                                <div>
                                    <button type="button" className="btn btn-secondary" onClick={clickCancel}>
                                        {_Tf("labels.cancel")}
                                    </button>
                                    <FormButton
                                        type="submit"
                                        className="btn btn-primary ms-2"
                                        disabled={!isSuperUser || !formData.model || !formData.server_id}
                                        isProcessing={isLoading}>
                                        {_Tf("labels.save")}
                                    </FormButton>
                                </div>
                            </div>
                        </div>
                    </Form>
                </div>
            </Offcanvas.Body>
        </Offcanvas>
    );
};

export default FormConfig;
